import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute, AdminRoute } from "./components/ProtectedRoute";
import { AppLayout } from "./components/AppLayout";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import VerifyEmail from "./pages/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import NewEvaluation from "./pages/NewEvaluation";
import Anesthetic from "./pages/Anesthetic";
import CaseHistory from "./pages/CaseHistory";
import Account from "./pages/Account";
import Knowledge from "./pages/Knowledge";
import Support from "./pages/Support";
import Suggest from "./pages/Suggest";
import Guides from "./pages/Guides";
import Pricing from "./pages/Pricing";
import { LegalPage, ContactPage } from "./pages/Legal";
import GuideDetail from "./pages/GuideDetail";
import PendingCases from "./pages/PendingCases";
import CaseResults from "./pages/CaseResults";
import Admin from "./pages/Admin";
import Organization from "./pages/Organization";
import Institutions from "./pages/Institutions";
import Tutorial, { AppTutorial } from "./pages/Tutorial";
import SpecialistReply from "./pages/SpecialistReply";
import Emergency, { AppEmergency } from "./pages/Emergency";
import NotFound from "./pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { if (!window.location.hash) window.scrollTo(0, 0); }, [pathname]);
  return null;
}

const withLayout = (el) => (
  <ProtectedRoute>
    <AppLayout>{el}</AppLayout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/guides" element={<Guides />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/institutions" element={<Institutions />} />
            <Route path="/tutorial" element={<Tutorial />} />
            <Route path="/emergency" element={<Emergency />} />
            <Route path="/app/emergency" element={withLayout(<AppEmergency />)} />
            <Route path="/r/:token" element={<SpecialistReply />} />
            <Route path="/terms" element={<LegalPage doc="terms" />} />
            <Route path="/privacy" element={<LegalPage doc="privacy" />} />
            <Route path="/clinical-agreement" element={<LegalPage doc="clinical" />} />
            <Route path="/refund-policy" element={<LegalPage doc="refund" />} />
            <Route path="/medical-disclaimer" element={<LegalPage doc="disclaimer" />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/guides/:slug" element={<GuideDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/app" element={withLayout(<Dashboard />)} />
            <Route path="/app/new" element={withLayout(<NewEvaluation />)} />
            <Route path="/app/anesthetic" element={withLayout(<Anesthetic />)} />
            <Route path="/app/cases" element={withLayout(<CaseHistory />)} />
            <Route path="/app/knowledge" element={withLayout(<Knowledge />)} />
            <Route path="/app/account" element={withLayout(<Account />)} />
            <Route path="/app/support" element={withLayout(<Support />)} />
            <Route path="/app/suggest" element={withLayout(<Suggest />)} />
            <Route path="/app/pending" element={withLayout(<PendingCases />)} />
            <Route path="/app/organization" element={withLayout(<Organization />)} />
            <Route path="/app/tutorial" element={withLayout(<AppTutorial />)} />
            <Route path="/app/cases/:id/results" element={withLayout(<CaseResults />)} />
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <AppLayout>
                    <Admin />
                  </AppLayout>
                </AdminRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
